import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[formControlName][appPhoneMask]',
})
export class PhoneMaskDirective {
  constructor(public ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;

    let trimmed = input.value.replace(/\D+/g, '');

    if (trimmed.length > 12) {
      trimmed = trimmed.slice(0, 12);
    }

    trimmed = trimmed.replace(/-/g, '');

    let numbers = [];

    numbers.push(trimmed.slice(0, 4));

    if (trimmed.slice(4, 11) !== '') numbers.push(trimmed.slice(4, 11));

    input.value = numbers.join('-');
  }
}
